import { CheckCircle2, AlertTriangle, AlertCircle, XCircle } from "lucide-react";

// Metadatos por resultado de escaneo. `label` es la clave en español (i18n);
// se traduce en el render con t(meta.label).
export const OUTCOME_META = {
  success:   { key: "success",   tone: "success", Icon: CheckCircle2,  label: "Recolectado" },
  duplicate: { key: "duplicate", tone: "warning", Icon: AlertTriangle, label: "Repetido" },
  already:   { key: "already",   tone: "info",    Icon: AlertCircle,   label: "Ya recolectado" },
  notfound:  { key: "notfound",  tone: "error",   Icon: XCircle,       label: "No encontrado" },
};

// Clases LITERALES por tono (Tailwind no resuelve nombres dinámicos).
export const FLASH_WRAP = {
  success: "border-status-success/30 bg-status-success-soft",
  warning: "border-status-warning/30 bg-status-warning-soft",
  info:    "border-status-info/30 bg-status-info-soft",
  error:   "border-status-error/30 bg-status-error-soft",
};

export const FLASH_TEXT = {
  success: "text-status-success",
  warning: "text-status-warning",
  info:    "text-status-info",
  error:   "text-status-error",
};

export const FLASH_ICON_BG = {
  success: "bg-status-success text-white",
  warning: "bg-status-warning text-white",
  info:    "bg-status-info text-white",
  error:   "bg-status-error text-white",
};
